import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import CommonTextInput from '../../../Common/Controller/Text';
import CommonCheckbox from '../../../Common/Controller/Checkbox';
import {
  handleCheckBoxChange,
  handleInputChange,
  handlePairPlateAutoCompleteChange,
  handleUpperInputBlur,
} from '../../../../util/Safety/DamageReport/Handler/changedInputHandler';
import { IS_NGL_CHASSIS_OPTION } from '../../../../constant/Safety/DamageReport/options';
import CommonAutoComplete from '../../../Common/Controller/AutoComplete';
import CustomTextInput from '../../../Common/Controller/Text/Custom';

const ChassisBasicInfoFields = ({
  isCompleted,
  damageReport,
  chassisOptions,
  isEditable,
}) => {
  const { watch, setValue } = useFormContext();

  useEffect(() => {
    const chassisValue = damageReport?.ch_no;
    const isNGLChassis = !!chassisOptions?.find(
      chassis => chassis.value === chassisValue,
    );
    setValue('isNGLChassis', isNGLChassis);
  }, [damageReport?.ch_no]);

  return (
    <div className="flex flex-col w-full mt-[-1px]">
      <div className="flex gap-x-[8px]">
        <div className="flex gap-x-[4px]">
          <div className="w-[56px]">
            <CommonCheckbox
              label="CHASSIS #"
              borderVisible
              options={IS_NGL_CHASSIS_OPTION}
              disabled={isCompleted || !isEditable}
              onChangeHandler={handleCheckBoxChange}
            />
          </div>
          <div className="pt-[14px] w-[159px]">
            <div className={`${watch('isNGLChassis') ? 'block' : 'hidden'}`}>
              <CommonAutoComplete
                labelVisible={false}
                inputName="ch_no_auto_complete"
                option={chassisOptions}
                disabled={isCompleted || !isEditable}
                onChangeHandler={props =>
                  handlePairPlateAutoCompleteChange({
                    plateInputName: 'ch_plate_no',
                    setValue,
                    ...props,
                  })
                }
                defaultValue={damageReport?.ch_no || ''}
                maxLength={32}
              />
            </div>
            <div className={`${!watch('isNGLChassis') ? 'block' : 'hidden'}`}>
              <CustomTextInput
                inputName="ch_no_text"
                maxLength={12}
                suppressLabelVisible
                suppressLabelContentVisible
                suppressErrorVisible
                suppressErrorContentVisible
                onChange={handleInputChange}
                onBlur={handleUpperInputBlur}
                disabled={isCompleted || !isEditable}
                defaultValue={damageReport?.ch_no || ''}
              />
            </div>
          </div>
        </div>
        <div className="w-[219px]">
          <CommonTextInput
            label="PLATE #"
            inputName="ch_plate_no"
            disabled={isCompleted || !isEditable}
            maxLength={8}
            onChangeHandler={handleInputChange}
            defaultValue={damageReport?.ch_plate_no || ''}
          />
        </div>
      </div>
    </div>
  );
};

export default ChassisBasicInfoFields;
